module.exports = __webpack_public_path__ + "static/media/lotteryMachine.205e84db.gif";